<span class="svg" [ngClass]="'size-'+size" title="{{title}}" aria-hidden="true"></span>
<!-- This image is used to detect when an image fails to load -->
<img #fallback [src]="imgSrc" alt="" class="fall-back-test">
